import { render, staticRenderFns } from "./verify-conf.vue?vue&type=template&id=64640640&"
import script from "./verify-conf.vue?vue&type=script&lang=js&"
export * from "./verify-conf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports